export default {"src":"/_next/static/media/grid.f5940afa.svg","height":495,"width":437};